export const SET_LAST_GENERATED_MEMBER = "SET_LAST_GENERATED_MEMBER";



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/clientActionTypes.js